import React from 'react'
import clsx from 'clsx'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'

import {
  selectArticles,
  selectArticle,
  fetchArticle
} from '../../../slices/article'
import useStyles from './styles'

const CREATING = 'CREATING'

const getName = (articles, id: string | null) => {
  if (id === null) {
    return 'Folders'
  }

  return articles[id]?.title ?? 'New document'
}

interface ArticleBreadcrumbsProps {
  className?: string
}

const ArticleBreadcrumbs: React.FC<ArticleBreadcrumbsProps> = ({
  className
}) => {
  const dispatch = useAppDispatch()
  const { selected, articles, creating } = useAppSelector(selectArticles)

  const [crumbs, setCrumbs] = React.useState<string[]>([])

  const classes = useStyles()

  // Constructs breadcrumb trail
  React.useEffect(() => {
    let id: string = selected
    const trail: string[] = [selected]

    while (id !== null) {
      const article = articles[id]
      if (!article) {
        // Need to fetch a parent
        if (id) {
          dispatch(fetchArticle(id))
        }
        break
      }

      const parentID: string | null = article.parent?.id

      if (!parentID) {
        // At the root
        break
      }

      // Expand
      if (!trail.includes(parentID)) {
        trail.push(parentID)
      }

      // Continue up the hierarchy
      id = parentID
    }

    if (creating) {
      trail.unshift(CREATING)
    }

    if (id) {
      trail.push(null)
    }

    setCrumbs(trail.reverse())
  }, [selected, articles, dispatch, creating])

  return (
    <div className={clsx(classes.root, className)}>
      {crumbs.map((id, i) => (
        <React.Fragment key={`${id}-${i}`}>
          {i > 0 && (
            <div
              className={clsx(
                classes.separator,
                id === selected && classes.currentCrumb
              )}
            >
              /
            </div>
          )}

          <div
            onClick={() => {
              if (id === CREATING) return

              if (id === selected && creating) {
                dispatch(selectArticle(id))
              }

              if (id !== selected) {
                dispatch(selectArticle(id))
              }
            }}
            className={clsx(
              classes.crumb,
              id === CREATING
                ? classes.currentCrumb
                : !creating && id === selected && classes.currentCrumb
            )}
          >
            {getName(articles, id)}
          </div>
        </React.Fragment>
      ))}
    </div>
  )
}

export default ArticleBreadcrumbs
